import { CakeSumsubGetAccessToken } from '../../schema';
import { CakeApiBase } from '../CakeApiBase';

export class SumsubApi extends CakeApiBase {
  async getAccessToken() {
    return this.requestManager.post<CakeSumsubGetAccessToken>('/sumsub/access-token');
  }
}
